/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-12 15:17:20
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getSettlementList
   * @description 公司管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getSettlementList(data) {
    return request.post(`${BASE_URL}/settlement/list`, data)
  },
  //  /**
  //  * @description 获取服务公司分类列表
  //  * @author YM
  //  * @date 2019-03-04
  //  * @returns
  //  */
  // getSettlementCategoryList() {
  //   return request.post('/settlement/category_list')
  // },

   /**
   * @description 获取服务公司分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getSettlementCategoryList() {
    return request.get(`${BASE_URL}/settlement/category_list`)
  },
  /**
   * saveCategory
   * @description 保存公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveSettlement(data) {
    return request.post(`${BASE_URL}/settlement/store`, data)
  },
  /**
   * getCategoryInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getSettlementInfo(id) {
    let data = {id:id}
    return request.post(`${BASE_URL}/settlement/get_info`, data)
  },
  /**
   * deleteCategoryInfo
   * @description 删除公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteSettlement(id) {
    let data = {id:id}
    return request.post('/settlement/delete', data)
  },
  /**
   * @description 分类排序
   * @author YM
   * @date 2019-03-07
   * @param {*} ids
   * @returns
   */
  orderSettlement(ids) {
    let data = {ids:ids}
    return request.post(`${BASE_URL}/settlement/order`,data)
  },
}